import {
    observable,
    makeAutoObservable,
    action,
    computed
} from "mobx";

import {DLVR_API_TOKEN, DLVR_FRONTEND_VERSION, LQ_STEPS, LQ_STEPS_TITLE} from "../config/constants";

const WebApp = window.Telegram.WebApp;

class LiqpayGeneratorStore {
    //State params:
    @observable callbackState = 'none' // [none | loading | error]
    @observable step = LQ_STEPS[0]
    @observable brand = null
    @observable terminalId = null
    @observable orderType = null
    @observable sumStr = '0'
    @observable orderSumMode = 'manual' // [manual | auto]
    @observable sum = 0
    @observable orders = null
    @observable order = null
    @observable errorText = 'Unknown error'
    @observable link = ''
    @observable linkCopied = false

    @observable showCouponInfo = false
    @observable couponCode = ""
    @observable couponData = null

    //Dynamical params:
    @observable terminals = []

    //Telegram Data:
    @observable user = {}
    @observable chat = {}

    constructor() {
        makeAutoObservable(this)

        if(typeof WebApp.initDataUnsafe.user === 'undefined')
            if(window.TEST_MODE) {
                this.user = { id: window.TEST_USER_ID, first_name: 'test', last_name: 'test' }
                this.chat = { id: window.TEST_CHAT_ID }
            }
            else
                this.user = { id: 0, first_name: '', last_name: '' }
        else {
            this.user = WebApp.initDataUnsafe.user
            this.chat = { id: this.user.id }
        }

        this.requestAPI({
            'type': 'access',
            'user': this.user
        })
    }

    @action
    loadTerminals(key) {
        this.brand = key
        this.requestAPI({
            'type': 'terminals',
            'brand': key
        })
    }

    @action
    loadOrderTypes(terminalIikoId) {
        this.terminalId = terminalIikoId
        this.step = 'order_type'
    }

    @action
    loadSumInput(orderTypeKey) {
        this.orderType = orderTypeKey
        this.orderSumMode = 'manual'
        this.sumStr = '0'
        this.step = 'sum'
    }

    @action
    loadAccept(order = null) {
        switch(this.orderSumMode) {
            case 'manual':
                this.sum = parseFloat(this.sumStr)
                break
            case 'auto':
                this.order = order
                this.orderType = this.syrve_alco_order_types.includes(this.order.order.orderType.id) ? 'alcohol' : 'regular'
                this.sum = parseFloat(this.order.order.sum)
                break
        }
        this.step = 'accept'
    }

    @action
    loadLink() {
        this.requestAPI({
            type: 'link',
            brand: this.brand,
            terminal: this.terminals.find(x => x.iiko_id === this.terminalId),
            order_type: this.orderType,
            order_sum_mode: this.orderSumMode,
            order: this.order,
            sum: this.sum,
            user: this.user,
            chat: this.chat
        })
    }

    @action
    loadOrders() {
        this.requestAPI({
            type: 'orders',
            terminal: this.terminals.find(x => x.iiko_id === this.terminalId)
        })
    }


    @action
    sumKeyPress(key) {
        let parts = this.sumStr.split('.')

        if(/[1-9]/.test(key)) {
            if(this.sumStr === '0')
                this.sumStr = key
            else if((this.sumStr.includes('.') && parts[1].length < 2) || (!this.sumStr.includes('.') && parts[0].length < 7))
                this.sumStr += key
        } else {
            switch(key) {
                case '0':
                    if(this.sumStr === '0') return;
                    if((this.sumStr.includes('.') && parts[1].length < 2) || !this.sumStr.includes('.'))
                        this.sumStr += key
                    break;
                case '.':
                    if(!this.sumStr.includes('.')) this.sumStr += key
                    break;
                case '<':
                    if(this.sumStr.length === 1)
                        this.sumStr = '0'
                    else this.sumStr = this.sumStr.substring(0, this.sumStr.length - 1)
                    break;
            }
        }
    }

    @action
    requestAPI(data) {
        const url = '/ajax/json/api';
        this.callbackState = 'loading';

        setTimeout(
            () =>
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .then(response => response.json())
            .then(responseData => {
                if(responseData.result)
                    switch(responseData.type) {
                        case 'terminals':
                            this.brand = data.brand;
                            this.step = 'terminal'
                            this.terminals = responseData.terminals
                            break
                        case 'orders':
                            this.orders = responseData.orders
                            this.syrve_alco_order_types = responseData.syrve_alco_order_types
                            this.orderSumMode = 'auto'
                            this.step = 'sum'
                            break
                        case 'link':
                            this.linkCopied = false
                            this.link = responseData.link
                            this.step = 'link'
                            break
                    }
                else {
                    this.callbackState = 'error'
                    this.errorText = responseData.message
                }
            })
            .finally(()=> {
                if(this.callbackState === 'loading')
                    this.callbackState = 'none'
            })
            , 500)
    }

    @action
    requestCouponAPI(code) {
        const url = 'https://dp.bl.kiev.ua/api/json/marketing-coupons.coupon-info';
        this.callbackState = 'loading';

        this.couponData = null;

        const formData = new FormData();

        formData.append('token', DLVR_API_TOKEN)
        formData.append('frontend_version', DLVR_FRONTEND_VERSION)
        formData.append('code', code)

        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Помилка сервера або підключення: ${response.status}`)
                }
                return response.json()
            })
            .then((data) => {
                console.log(data)
                if(data.result === true)
                    this.couponData = data?.coupon
            })
            .catch((error) => {
                console.error(error)
            })
            .finally(() => {
                this.showCouponModal()
                this.callbackState = 'none'
            })
    }


    @action
    goBack() {
        const index = LQ_STEPS.indexOf(this.step);

        if(index === 0)
            window.Telegram.WebApp.close();
        else
            this.step = LQ_STEPS[index-1];
    }

    @action
    copyLink() {
        navigator.clipboard.writeText(this.link)
            .then(()=>{
                console.log('Copied!')
                this.linkCopied = true;
            })
            .catch(()=>{
                console.log('Error copy :(')
            })
    }

    @computed
    getCurrentStepTitle() {
        const step = LQ_STEPS.indexOf(liqpayGeneratorStore.step) + 1;
        console.log(step);
        let stepTitle = LQ_STEPS_TITLE[step - 1]
        if(this.step == 'sum' && this.orderSumMode == 'auto')
            stepTitle = 'Оберіть замовлення';
        return stepTitle;
    }

    @action showCouponModal() {
        this.showCouponInfo = true;
    }

    @action hideCouponModal() {
        this.showCouponInfo = false;
    }

    @action setCouponCode(code) {
        this.couponCode = code
    }
}

const liqpayGeneratorStore = new LiqpayGeneratorStore();
export default liqpayGeneratorStore;
